module.exports = __webpack_public_path__ + "static/media/lend_eth.73dc8340.svg";